import { Component } from '@angular/core';

import { ReportsService } from '../../../services/reports.service';

@Component({
  selector: 'custom-status-bar-row-count',
  template: `
    <div *ngIf="rptService.ssrTotalRowsData.total" style="padding: 8px">
      <span>{{ 'AGGRIDLOCALE.totalRows' | translate }}:&nbsp;</span>
      <span style="color: black">{{ rptService.ssrTotalRowsData.total }}</span>
    </div>
  `,
  styles: [],
})
export class CustomStatusBarRowCountComponent {
  constructor(public rptService: ReportsService) {}

  agInit(): void {}
}
